// Polyfill for IE 

try{
    if(void 0 == Event)
        function Event( event, params ) {
            params = params || { bubbles: false, cancelable: false, detail: undefined };
            var evt = document.createEvent( 'CustomEvent' );
            evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
            return evt;
        }
}catch(err){

}


(function(){

    function scrollIntoView(el){
        const yOffset = -75; 
        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
    } 

    // function checkThyButton(buttonATC){
    //     const pdpMarker = document.querySelector(".product-section"); 
    //     const atcText =  buttonATC.innerText.trim().toLowerCase();
    //     const bisTrigger = document.querySelector("#BIS_trigger");
    //     pdpMarker.classList.remove('sold_out_pdp_mark_revert');
    //     if(bisTrigger && bisTrigger != void 0){
    //         if(bisTrigger.style.display != "none"){
    //             pdpMarker.classList.add('sold_out_pdp_mark_revert');
    //         }
    //     } 
    //     if( ( buttonATC.classList.contains("disabled") || buttonATC.disabled || atcText.includes("sold") )  ){
    //         pdpMarker.classList.add('sold_out_pdp_mark_revert');
    //     }
    //     if(buttonATC.classList.contains("sbb")){
    //         pdpMarker.classList.add('sold_out_pdp_mark')
    //     }else{
    //         pdpMarker.classList.remove('sold_out_pdp_mark')
    //     }
    // }

    document.addEventListener('DOMContentLoaded' , function(){

        const mainTemplate = document.getElementById("productMainTemplate");
        try{
            const swatchedForm = document.querySelector(".productSwatchedForm");
            const swatches = document.querySelectorAll(".swatch_holder");
            const swatchInner = document.querySelectorAll(".swatch_holder div[data-swatch-variant]");

            //Setup Colors for the Swatches 
            if(swatchInner != null && swatchInner.length > 0 ){
                for(var i = 0; i < swatchInner.length; i++){
                    const swatchVariant =  swatchInner[i].dataset.valueunescaped;
                    const findValue = document.querySelector("div[data-colorname='"+swatchVariant+"']");
                    var colorHex = "white";
                    var colorHex2 = null;
                    var noSecondaryValueFound = true;
                    if(findValue != null){
                        colorHex = findValue.dataset.colorvalue;                        
                        imgURL = findValue.dataset.imagevalue;                        
                        if(findValue.dataset.colorvalue2 != void 0 && findValue.dataset.colorvalue2 != null){
                            noSecondaryValueFound = false;
                            colorHex2 = findValue.dataset.colorvalue2
                        }
                    }
                    if(imgURL != null || imgURL != undefined){
                        swatchInner[i].style.backgroundImage = `url('${imgURL}')`;
                        swatchInner[i].style.backgroundPosition = "center";
                    } else {
                        if(noSecondaryValueFound){
                            swatchInner[i].style.backgroundColor = colorHex;
                        }else{                        
                            swatchInner[i].style.borderLeft = `15px  solid ${colorHex2}`;
                            swatchInner[i].style.borderRight = `15px  solid ${colorHex}`;
                            swatchInner[i].style.borderTop = `15px  solid ${colorHex}`;
                            swatchInner[i].style.borderBottom = `15px  solid ${colorHex2}`;
                            swatchInner[i].style.transform = `rotate(-135deg)`;
                        }
                    }                                        
                }
                setTimeout(function(){
                    document.querySelector(".productSwatchedForm").classList.add('loaded');
                },50);
            }
            // Setup Clicks
            for(var i = 0; i < swatches.length; i++){
                swatches[i].addEventListener('click', function(e){
                    const self = this;
                    const parent = self.parentNode;
                    const theForm = document.querySelector('.product-block.product-form-block');
                    const formWithinTheForm = theForm.querySelector('form');
                    theForm.classList.add('form__loading');
                    formWithinTheForm.classList.add('form__loading');
                    try{
                        const inMessage = document.querySelector("#in-message");
                        inMessage.classList.add('form__loading');
                    }catch(err){
                    
                    }
                    parent.querySelector(".selected").classList.remove('selected');
                    setTimeout(function(){
                        self.classList.add('selected');
                        const swatchInner = self.querySelector('.swatch');
                        const variantType = swatchInner.getAttribute('value');
                        const selectorFor = swatchInner.getAttribute('selector-for');
                        parent.parentNode.querySelector(".product_selectVariant-"+ selectorFor).innerText = variantType;
                        const select = document.querySelector("select[selector-for='"+selectorFor+"']");
                        select.value = variantType;
                        select.dispatchEvent(new Event('change'));

                        console.log(variantType)
                        
                        let variants =  document.querySelectorAll('.color-selector-baby')
                        let selecteds =  document.querySelectorAll('.pdp_color_swatches .selected .swatch')
                        if(selecteds.length>1){
                            let first = selecteds[0]
                            let second = selecteds[1]
                                for(let variant of variants){
                                    let color1 = first.getAttribute('value')
                                    let color2 = second.getAttribute('value')
                                    let color_compare_1 = variant.getAttribute("data-color")
                                    let color_compare_2 = variant.getAttribute('data-color2')
                                    if(color1 == color_compare_1 && color2 == color_compare_2){
                                        const baby = document.getElementById('babylist-button')
                                        baby.href = "javascript: bl.addToRegistry({images:'"+variant.getAttribute('data-images')+"',price: '"+variant.getAttribute('data-price')+"',title: '"+variant.getAttribute('data-title')+"',url: '"+variant.getAttribute('data-url') +"'});"
                                        break;
                                    }
                                }
                        }else{
                            for(let variant of variants){
                                let color = variant.getAttribute('data-color')
                                console.log(color,variantType,color==variantType,"testcolor")
                                if(color.toLowerCase() == variantType.toLowerCase()){
                                    const baby = document.getElementById('babylist-button')
                                    baby.href = "javascript: bl.addToRegistry({images:'"+variant.getAttribute('data-images')+"',price: '"+variant.getAttribute('data-price')+"',title: '"+variant.getAttribute('data-title')+"',url: '"+variant.getAttribute('data-url') +"'});"
                                    console.log(baby.href,"babytest2")
                                   
                                }
                            }
                        }
                        /*
                        */
                    },10)
                })
            } 
        }catch(err){
            document.querySelector(".productSwatchedForm").classList.add('loaded');            
            console.log("Swatch Handler Error ! " , err );
        }

        //checkThyButton(document.querySelector("button[data-add-to-cart]"));
        
    });

    // Mutation Observer Waits for element or object to change and fire an event
    function waitForElm(selector) {
        return new Promise(function(resolve) {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
            const observer = new MutationObserver(function(mutations){
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }
    // PDP Marker / Adds a class when a product is sold out to handle absolute positioning 
    // waitForElm("button[data-add-to-cart]").then(function(buttonATC){
    //     const MutationObserver = window.MutationObserver;
    //     const observer = new MutationObserver(function(mutations) { 
    //         checkThyButton(buttonATC);
    //         observer.disconnect();
    //         setTimeout(function(){
    //             const config = {attributes: true,  childList: true,  characterData: true};
    //             observer.observe(buttonATC, config);
    //         },100);
    //     });
    //     const config = {attributes: true,  childList: true,  characterData: true};
    //     observer.observe(buttonATC, config);
    // });
    //Main Caller 
    waitForElm('[data-shopify="payment-button"]').then(function(noMark){
        const MutationObserver = window.MutationObserver;
        const observer = new MutationObserver(function(mutations) { 
            const pdpMarker = document.querySelector(".product-section"); 
            if(noMark.style.display != 'none' || window.getComputedStyle(noMark).display === "none"){
                pdpMarker.classList.remove('sold_out_pdp_null_mark');
            }else{
                pdpMarker.classList.add('sold_out_pdp_null_mark');
            }
            observer.disconnect();
            const config = {attributes: true,  childList: true,  characterData: true};
            observer.observe(noMark, config);
        });
        const config = {attributes: true,  childList: true,  characterData: true};
        observer.observe(noMark, config);
    });
     //Notify Avaiable
    //  waitForElm('#BIS_trigger').then(function(noMark){
    //     const pdpMarker = document.querySelector(".product-section"); 
    //     pdpMarker.classList.add('sold_out_pdp_notify_mark');
    //     const MutationObserver = window.MutationObserver;
    //     const observer = new MutationObserver(function(mutations) { 
    //         if(noMark.style.display == 'none'){
    //             pdpMarker.classList.remove('sold_out_pdp_notify_mark');
    //         }else{
    //             pdpMarker.classList.add('sold_out_pdp_notify_mark');
    //         }
    //         observer.disconnect();
    //         const config = {attributes: true,  childList: true,  characterData: true};
    //         observer.observe(noMark, config);
    //     });
    //     const config = {attributes: true,  childList: true,  characterData: true};
    //     observer.observe(noMark, config);
    // });
    // Add Brakets around review Number & disconnect the Observer
    waitForElm(".product-single__meta .product_reviews_badge .jdgm-prev-badge__text").then(function(reviewCount){
        const MutationObserver = window.MutationObserver;
        const observer = new MutationObserver(function(mutations) {
            const reviewText = reviewCount.innerText;
            const split = reviewText.split(' ');
            const remake =  '(' + split[0] + ')';
            const fullString = remake + " " + split[1];
            reviewCount.innerText = fullString; 
            observer.disconnect();
        });
        const config = {attributes: true,  childList: true,  characterData: true};
        observer.observe(reviewCount, config);
    })


document.addEventListener('DOMContentLoaded', function() {
    function hideUnavailableSwatches() {
        // Get all product variants data
        const productJsonElements = document.querySelectorAll('[id^="ProductJson-"]');
        if (!productJsonElements.length) return;

        productJsonElements.forEach((element) => {
            const variants = JSON.parse(element.textContent);
            const sectionId = element.id.replace('ProductJson-', '');
            const section = document.querySelector(`[data-product-id="${sectionId}"]`);
            if (!section) return;

            // Get all swatch containers
            const swatchContainers = section.querySelectorAll('.pdp_swatches');

            
            // Function to update available options based on current selection
            function updateAvailableOptions() {
                // Get currently selected frame color
                const frameColorContainer = swatchContainers[0]; // Assuming frame color is first
                const selectedFrame = frameColorContainer.querySelector('.selected .swatch');
                const selectedFrameColor = selectedFrame ? selectedFrame.getAttribute('value') : null;

                // Update seat color swatches
                const seatColorContainer = swatchContainers[1]; // Assuming seat color is second
                if (seatColorContainer && selectedFrameColor) {
                    const seatSwatches = seatColorContainer.querySelectorAll('.swatch_holder');
                    
                    seatSwatches.forEach(swatch => {
                        const seatColor = swatch.querySelector('.swatch').getAttribute('value');
                        
                        // Check if this combination exists in available variants
                        const isAvailable = variants.some(variant => 
                          //  variant.available && 
                            variant.options[0] === selectedFrameColor && 
                            variant.options[1] === seatColor
                        );

                        // Hide or show the swatch based on availability
                        swatch.style.display = isAvailable ? 'block' : 'none';
                    });
                }
            }

            // Add click event listeners to frame color swatches
            const frameSwatches = swatchContainers[0].querySelectorAll('.swatch_holder');
            frameSwatches.forEach(swatch => {
                swatch.addEventListener('click', () => {
                    setTimeout(updateAvailableOptions, 100); // Small delay to ensure selection is updated
                });
            });

            // Initial update
            updateAvailableOptions();
        });
    }

    // Initialize the functionality
    hideUnavailableSwatches();
});

})()